import { NavLink, Link } from "react-router-dom";

const links = [
  { to: "/projects", label: "Projects" },
  { to: "/about", label: "About" },
  { to: "/process", label: "Process" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => (
  <header className="bg-canvas border-b border-hairline" data-testid="site-header">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-4">
      <Link to="/" className="font-display text-2xl tracking-tight text-ink" data-testid="header-wordmark">
        Sandquist Construction
      </Link>
      <nav className="flex flex-wrap gap-x-7 gap-y-2" data-testid="header-nav" aria-label="Main">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            className={({ isActive }) =>
              `font-label text-xs uppercase tracking-[0.18em] transition-colors duration-200 ${
                isActive ? "text-plaster" : "text-ink hover:text-plaster"
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
    </div>
  </header>
);
